import React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import ProductsGrid from './ProductsGrid'


import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import Cookies from 'universal-cookie';
import {useAuth} from "../utils/useAuth";

export default function HotspotGrid(props) {
    const [loadingHotspots, setLoadingHotspots] = React.useState(false);
    const [selectedHotspot, setSelectedHotspot] = React.useState("");
    const [openCreateHotspotDialog, setOpenCreateHotspotDialog] = React.useState(false);
    const [input, setInput] = React.useState("");
    const [products, setProducts] = React.useState([])
    const getListStyle = { display: 'flex', overflow: 'auto' }
    const { getAccessToken } = useAuth();

    const [state, setState] = React.useState({
        openSuccess: false,
        openError: false,
        vertical: 'top',
        horizontal: 'right',
        successMessage: '',
        errorMessage: ''
    });
    const { vertical, horizontal, openSuccess, successMessage, openError, errorMessage } = state;

    const handleClose = () => {
        setState({ ...state, openSuccess: false, openError: false });
    };

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    React.useEffect(() => {
        setSelectedHotspot("All")
        filterProducts("")
    }, [props.currentPage]);

    React.useEffect(() => {
        setSelectedHotspot("All")
        filterProducts("")
    }, [props.value]);

    React.useEffect(() => {
        setSelectedHotspot("All")
        filterProducts("")
    }, [props.searchText]);

    React.useEffect(() => {
        filterProducts(selectedHotspot)
    }, [props.display]);

    function clickHotspot(hotspot) {
        setSelectedHotspot(hotspot)
        filterProducts(hotspot)
    }

    const handleSetLoading = (bool) => {
        setLoadingHotspots(bool)
    };

    const onDragEnd = (result) => {
        if (!result.destination) return;

        handleSetLoading(true)
        reorder(result.source.index, result.destination.index)
    }

    async function reorder(startIndex, endIndex) {
        // const hotspots = props.display.hotspot.sort((a, b) => parseFloat(a.position) - parseFloat(b.position))
        const hotspots = props.display.hotspots
        const result = Array.from(hotspots);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed)


        result.forEach(function (item, i) {
            var newItem = item
            newItem.position = (i + 1).toString()
            postProduct(newItem)
            props.fetchDisplays()
        })

        setTimeout(function () {
            handleSetLoading(false)
        }, 2500)
    }

    const getAuthHeaders = async () => {
        const token = await getAccessToken();
        if (!token) throw new Error("Not authenticated");
        const cookies = new Cookies();
        const hashCode = cookies.get("hashCode") || "";
        return {
            Authorization: token + hashCode,
            "Content-Type": "application/json",
        };
    };

    const postProduct = async (item) => {
        try {
            const headers = await getAuthHeaders();

            const body = {
                id: item.id,
                name: item.name,
                displayID: item.displayID,
                timestamp: item.timestamp,
                position: item.position,
            };

            const res = await fetch(process.env.REACT_APP_API_ENDPOINT + "hotspots", {
                method: "POST",
                headers,
                body: JSON.stringify(body),
            });

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return await res.json();
        } catch (err) {
            console.error("postProduct error:", err);
        }
    };

    const filterProducts = (hotspot) => {
        if (!hotspot || hotspot === "All") {
            let filtered = [];
            props.display.hotspots.forEach((h) => h.products.forEach((p) => filtered.push(p)));
            setProducts(filtered);
        } else {
            const target = props.display.hotspots.find((h) => h.id === hotspot.id);
            if (target?.products) setProducts(target.products);
        }
    };

    const createHotspot = async (title) => {
        try {
            const headers = await getAuthHeaders();

            const body = {
                id: generateUniqSerial(),
                name: title,
                displayID: props.display.id,
                timestamp: Math.floor(Date.now() / 1000).toString(),
                position: "",
            };

            const res = await fetch(process.env.REACT_APP_API_ENDPOINT + "hotspots", {
                method: "POST",
                headers,
                body: JSON.stringify(body),
            });

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            setState({ openSuccess: true, openError: false, successMessage: "Hotspot added successfully!" });
            setOpenCreateHotspotDialog(false);
            props.fetchDisplays();
        } catch (err) {
            console.error("createHotspot error:", err);
            setState({ openError: true, openSuccess: false, errorMessage: "Something went wrong." });
        }
    };

    const updateHotspot = async (hotspot, title) => {
        try {
            const headers = await getAuthHeaders();

            const body = {
                id: hotspot.id,
                name: title,
                displayID: hotspot.displayID,
                timestamp: Math.floor(Date.now() / 1000).toString(),
                position: hotspot.position,
            };

            const res = await fetch(process.env.REACT_APP_API_ENDPOINT + "hotspots", {
                method: "POST",
                headers,
                body: JSON.stringify(body),
            });

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            setOpenCreateHotspotDialog(false);
            props.fetchDisplays();
        } catch (err) {
            console.error("updateHotspot error:", err);
        }
    };

    function generateUniqSerial() {
        return 'xxxx-xxxx-xxx-xxxx'.replace(/[x]/g, (c) => {
            const r = Math.floor(Math.random() * 16);
            return r.toString(16);
        });
    }

    return (
        <div style={{}}>
            <Grid item xs>

                <Typography gutterBottom variant="h5" className='gucci_text'>
                    Hotspots
                    <Button
                        className='add_hotspot_button add_hotspot complete_button'
                        onClick={() => setOpenCreateHotspotDialog(true)}
                        color="primary"
                        startIcon={<AddIcon color='error' />}
                        style={{ marginTop: '-4px', marginLeft: '4px' }}>
                    </Button>
                </Typography>

                <Box m={2} />

                {loadingHotspots ?
                    <div style={{ textAlign: 'center' }}>
                        <CircularProgress />
                    </div>
                    :
                    <div style={getListStyle} className='product_list' >
                        <ButtonGroup variant="text" aria-label="text primary button group">
                            {/* Pulsante "All" */}
                            <Button
                                className={selectedHotspot === "All" ? 'gucci_text_bold custom_hotspot_button selected_hotspot black' : 'gucci_text custom_hotspot_button black'}
                                onClick={() => clickHotspot("All")}
                            >
                                All
                            </Button>

                            <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId="droppable" direction="horizontal">
                                    {(provided) => (
                                        <Box ref={provided.innerRef} {...provided.droppableProps} display="flex">
                                            {props.display.hotspots.map((hotspot, index) => (
                                                <Draggable key={hotspot.id} draggableId={hotspot.id.toString()} index={index}>
                                                    {(provided) => (
                                                        <Button
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={selectedHotspot.id === hotspot.id ? 'gucci_text_bold custom_hotspot_div selected_hotspot black' : 'gucci_text custom_hotspot_div black'}
                                                            onClick={() => clickHotspot(hotspot)}
                                                        >
                                                            {hotspot.name}
                                                        </Button>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </Box>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </ButtonGroup>

                    </div>
                }



                <Grid item xs={12}>
                    <Box style={{ cursor: 'pointer' }}>
                        <ProductsGrid
                            user={props.user}
                            setDisplays={props.setDisplays}
                            fetchDisplays={props.fetchDisplays}
                            clickHotspot={(hotspot) => clickHotspot(hotspot)}
                            updateHotspot={updateHotspot}
                            products={products}
                            setProducts={setProducts}
                            setLoadingHotspots={props.setLoadingHotspots}
                            hotspot={selectedHotspot}
                        />
                    </Box>
                </Grid>

            </Grid>

            <Dialog fullWidth maxWidth={'sm'} open={openCreateHotspotDialog} onClose={() => setOpenCreateHotspotDialog(false)} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Create an Hotspot</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Create an Hotspot for the display named: {props.display.name}
                    </DialogContentText>
                    <TextField
                        className='text_hotspot'
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Hotspot name"
                        variant="standard"
                        fullWidth
                        value={input}
                        onChange={e => setInput(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button className='black template_button' onClick={() => setOpenCreateHotspotDialog(false)} color='primary' >
                        Cancel
                    </Button>
                    <Button className='red  template_button' onClick={() => createHotspot(input)} color='primary'>
                        Create
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                open={openSuccess}
                autoHideDuration={3000}
                onClose={handleClose}
                message="I love snacks"
                key={vertical + horizontal}
            >
                <Alert onClose={handleClose} severity="success" dx={{ width: '300px' }}>
                    {successMessage}
                </Alert>
            </Snackbar>

            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                open={openError}
                onClose={handleClose}
                autoHideDuration={3000}
                message=""
                key={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
            >
                <Alert onClose={handleClose} severity="error" dx={{ width: '300px' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>

        </div>
    )
}
